 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"bios":"bios","dashboard~highlights~pandemic~performance":"dashboard~highlights~pandemic~performance","dashboard":"dashboard","csr":"csr","highlights":"highlights","pandemic":"pandemic","performance":"performance","letters":"letters","slideshow":"slideshow","stride":"stride","videos":"videos"}[chunkId]||chunkId) + "." + {"chunk-5077d390":"f3e8b968","bios":"fd36c89c","chunk-426d6ee6":"d76e0361","dashboard~highlights~pandemic~performance":"837ac7da","dashboard":"1e700a03","csr":"6319cfa8","highlights":"200d214f","pandemic":"9a4ec6f0","performance":"ecf09f31","letters":"c28d248c","slideshow":"564c412e","stride":"060625a3","videos":"fe433b29","chunk-17aa7c57":"35041be4","chunk-1707d897":"53725572","chunk-259d39f5":"12450ef5","chunk-4b5ba50e":"90bb3d12","chunk-9a2c0b4e":"f799eadc","chunk-bbabf54a":"fc0aa1db","chunk-cf4d6156":"7edfe937","chunk-181c430f":"bcbb511b","chunk-414c1698":"e52b5d59","chunk-46437962":"ad9db9e6","chunk-4b8f45ff":"465c7420","chunk-7337340f":"2ee5b44b","chunk-8ad7807c":"0bf7e869","chunk-2d0aba0d":"757a2232","chunk-2d0b6edb":"86b2cfef","chunk-2d0b9bf4":"a63dfd76","chunk-2d0d042a":"779b55d0","chunk-2d0db7de":"3a7b69f9","chunk-2d0f0841":"4fdd38f0","chunk-2d0f0f48":"1f9f6d9f","chunk-2d20f764":"56cfcbe2","chunk-2d2254b4":"af7d5ea4","chunk-2d22a18a":"36d49c21","chunk-2d22d607":"d5d363ed","chunk-8fdca3b2":"f38178b2","chunk-9c2c096a":"83b6d1c8","chunk-2cd4b679":"dcea3b74","chunk-426ab78b":"93e822f2","chunk-a672a900":"f047d28c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"bios":1,"chunk-426d6ee6":1,"dashboard":1,"csr":1,"highlights":1,"pandemic":1,"performance":1,"letters":1,"slideshow":1,"stride":1,"videos":1,"chunk-17aa7c57":1,"chunk-1707d897":1,"chunk-259d39f5":1,"chunk-4b5ba50e":1,"chunk-9a2c0b4e":1,"chunk-bbabf54a":1,"chunk-cf4d6156":1,"chunk-181c430f":1,"chunk-414c1698":1,"chunk-46437962":1,"chunk-4b8f45ff":1,"chunk-7337340f":1,"chunk-8ad7807c":1,"chunk-8fdca3b2":1,"chunk-9c2c096a":1,"chunk-2cd4b679":1,"chunk-426ab78b":1,"chunk-a672a900":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"bios":"bios","dashboard~highlights~pandemic~performance":"dashboard~highlights~pandemic~performance","dashboard":"dashboard","csr":"csr","highlights":"highlights","pandemic":"pandemic","performance":"performance","letters":"letters","slideshow":"slideshow","stride":"stride","videos":"videos"}[chunkId]||chunkId) + "." + {"chunk-5077d390":"31d6cfe0","bios":"bdb8d51a","chunk-426d6ee6":"b3c7b160","dashboard~highlights~pandemic~performance":"31d6cfe0","dashboard":"abed0d23","csr":"3aae4101","highlights":"11899a5d","pandemic":"43d0c778","performance":"7fcb0d9d","letters":"78450f67","slideshow":"d309e556","stride":"53021d78","videos":"c871fd53","chunk-17aa7c57":"47b65726","chunk-1707d897":"056dc36e","chunk-259d39f5":"728aced8","chunk-4b5ba50e":"ce6c8dcf","chunk-9a2c0b4e":"0918c8d8","chunk-bbabf54a":"b489bd8a","chunk-cf4d6156":"7d22bff8","chunk-181c430f":"d2c70920","chunk-414c1698":"f7a9d372","chunk-46437962":"b75a3e38","chunk-4b8f45ff":"f7a9d372","chunk-7337340f":"f7a9d372","chunk-8ad7807c":"104827e4","chunk-2d0aba0d":"31d6cfe0","chunk-2d0b6edb":"31d6cfe0","chunk-2d0b9bf4":"31d6cfe0","chunk-2d0d042a":"31d6cfe0","chunk-2d0db7de":"31d6cfe0","chunk-2d0f0841":"31d6cfe0","chunk-2d0f0f48":"31d6cfe0","chunk-2d20f764":"31d6cfe0","chunk-2d2254b4":"31d6cfe0","chunk-2d22a18a":"31d6cfe0","chunk-2d22d607":"31d6cfe0","chunk-8fdca3b2":"f7a9d372","chunk-9c2c096a":"d95edf7a","chunk-2cd4b679":"bfdca083","chunk-426ab78b":"d7491f94","chunk-a672a900":"a422d16d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
